import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=26a485da&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=26a485da&scoped=true&lang=scss&"
import style1 from "./addGoods.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a485da",
  null
  
)

export default component.exports